import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useBankAccountStore = defineStore('bankAccount', {
  state: () => ({
    bankAccounts: {},
    unsubs: [],
  }),
  persist: { paths: ['bankAccounts'] },
  getters: {
    allBankAccounts(state) {
      return Object.values(state.bankAccounts)
        .filter((a) => a.isActive !== false)
        .sort((a, b) => {
          const orderA = Number(a.order) || 0;
          const orderB = Number(b.order) || 0;
          if (orderA !== orderB) return orderA - orderB;
          return (a.name || '').localeCompare(b.name || '');
        });
    },
    getAccountById: (state) => (id) => state.bankAccounts[id] || null,
  },
  actions: {
    upsert({ id, value }) {
      this.bankAccounts = { ...this.bankAccounts, [id]: value };
    },
    remove(id) {
      const bankAccounts = { ...this.bankAccounts };
      delete bankAccounts[id];
      this.bankAccounts = bankAccounts;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.bankAccounts = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      const snapshotQuery = collection(firestore, 'bankAccounts');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('BankAccount - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    },
  },
});
